import type { BikeParkMetadata, MtbTrailRelatedPlace } from "~/lib/api";
import { cn } from "~/lib/utils";
import { BikeParkAccessPills } from "./BikeParkAccessPills";
import { RidingSignature } from "./RidingSignature";
import { TrailDifficultySummary } from "./TrailDifficultySummary";

interface BikeParkStatsProps {
  metadata: BikeParkMetadata | null | undefined;
  trails: MtbTrailRelatedPlace[];
  compact?: boolean;
  outline?: boolean;
  className?: string;
}

export function BikeParkStats({ metadata, trails, compact, outline, className }: BikeParkStatsProps) {
  if (!metadata && trails.length === 0) return null;

  return (
    <div className={cn("flex flex-col", { "gap-1": compact, "gap-2": !compact }, className)}>
      {compact ? <RidingSignature trails={trails} /> : metadata && <BikeParkAccessPills metadata={metadata} />}
      <TrailDifficultySummary trails={trails} compact={compact} outline={outline} />
    </div>
  );
}
